<template>
  <div class="iconfont" @click="respondevent">
    <el-tooltip class="item" effect="dark" :content="message" placement="top">
      <ig-icon
        v-if="mapType === 'iconfont'"
        :name="mapping"
        :style="[tableData.size, tableData.color, colors]"
      ></ig-icon>
    </el-tooltip>

    <!-- text -->
    <el-popover
      placement="top-start"
      :width="popoverWidth"
      :trigger="trigger"
    >
      <component
        v-if="componentName"
        :is="componentName"
        :scope="scope"
        :table-data="tableData"
        v-bind="$attrs"
        v-on="$listeners"
      ></component>
      <div v-else v-html="multidataMapping">
      </div>
      <div
        slot="reference"
        v-if="mapType === 'text'"
        :style="[colors]"
        class="mapping"
      >
        {{ mapping }}
      </div>
    </el-popover>

    <!-- 换行 -->
    <div v-for="(item, index) in multidata" :key="item.id || index">
      <el-popover
        placement="top-start"
        :width="popoverWidth"
        :trigger="trigger"
        :content="item.content || item"
      >
        <div slot="reference" class="multidata" v-if="mapType === 'multidata'">
          <div
            v-if="multidataType == 'text'"
            class="multidata-data"
            :style="[colors]"
            @click="multidataEvent(item)"
          >
            {{ item.content || item }}
          </div>
          <span @click="multidataEvent(item)" v-if="multidataType == 'icon'">
            <ig-icon :style="[colors]" :name="item.icon"></ig-icon>
          </span>
        </div>
      </el-popover>
    </div>
     <!-- d -->
  </div>
</template>

<script>
import customComponent from '@/components/tools/customComponent';
import account from './index.js';
import { judgeNullValue } from '@/utils/index.js';
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  computed: {
    componentName() {
      let { scope, tableData } = this;
      if (!(scope && tableData)) return false;
      return tableData.componentName || false;
    },
    trigger() {
      return this.tableData.trigger || 'manual';
    },
    popoverWidth() {
      return this.tableData.popoverWidth || '400';
    },
    mapType() {
      return this.tableData.mapType;
    },
    multidataType() {
      return this.tableData.multidataType || 'text';
    },
    mapping() {
      let { scope, tableData } = this;
      if (tableData.parentEvent) {
        return tableData.parentEvent(scope.row[tableData.bind], scope.row);
      }

      if (!judgeNullValue(scope.row[tableData.bind])) {
        return scope.row[tableData.bind].toString();
      }
      return '-';
    },
    multidata() {
      return (
        (this.tableData.multidata &&
          this.tableData.multidata(
            this.scope.row[this.tableData.bind],
            this.scope.row
          )) ||
        '-'
      );
    },
    multidataMapping()
    {
      return (
        (this.tableData.multidataMapping &&
          this.tableData.multidataMapping(
            this.scope.row
          )) ||
        '-'
      );
    },
    colors() {
      if (typeof this.tableData.colors == 'function') {
        return this.tableData.colors(this.scope.row);
      } else {
        return this.tableData.colors;
      }
    },
    message() {
      return (
        (this.tableData.message && this.tableData.message(this.scope.row)) ||
        '-'
      );
    }
  },
  methods: {
    // 响应事件
    respondevent() {
      this.tableData.respondevent &&
        this.tableData.respondevent(this.scope.row);
    },
    multidataEvent(item) {
      this.tableData.multidataEvent &&
        this.tableData.multidataEvent(item, this.scope.row);
    }
  },
  components: { ...account, customComponent }
};
</script>

<style scoped lang="scss">
.mapping {
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.multidata {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  .multidata-data {
    width: 100%;
    padding: 12px 0;
  }
}
</style>
